import { useFormikContext } from "formik";
import React, { Fragment, useState } from "react";
import Field from "../Field";
import Button from "../Button";
import Loader from "../Loader";
import { CheckBox } from "../Input";
import { useFormContext } from "../../context/FormContext";
import { splitFieldsIntoPages, pageHasErrors, collectPageFieldNames } from "../../utils";

export default function Form({ fields }) {
  const { handleSubmit, isSubmitting, resetForm, errors, setFieldTouched, validateForm } = useFormikContext();
  const { merchant } = useFormContext();
  const [currentPage, setCurrentPage] = useState(0);
  if (!fields) return <p>No form fields</p>;
  if (fields && fields.length < 1) return <p>No form fields</p>;

  if(typeof fields === 'string'){
    fields = JSON.parse(fields)
  }

  // A form with no new_page markers produces exactly one page here, so
  // existing forms render identically to before this feature existed.
  const pages = splitFieldsIntoPages(fields);
  const isMultiPage = pages.length > 1;
  const currentPageFields = pages[currentPage] || fields;
  const isLastPage = currentPage === pages.length - 1;

  const handleNext = async (event) => {
    // type="button" already keeps a click from submitting the enclosing
    // <form>, but guard explicitly too so this can never fall through to
    // Formik's handleSubmit regardless of how the click reaches us.
    event?.preventDefault();
    event?.stopPropagation();
    // Touch this page's fields first so a blocked Next actually surfaces
    // error messages, instead of silently refusing to advance.
    collectPageFieldNames(currentPageFields).forEach((name) => setFieldTouched(name, true, false));
    const currentErrors = await validateForm();
    if (pageHasErrors(currentPageFields, currentErrors)) return;
    setCurrentPage((page) => Math.min(page + 1, pages.length - 1));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleBack = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    setCurrentPage((page) => Math.max(page - 1, 0));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleDecline = ()=>{
    
  }
  
  const Modalcontent = ()=>(
    <div className="consent-modal">
    {/* Header with Nigerian Coat of Arms feel */}
    <div className="consent-header">
      <div className="gov-badge">
        {/* {merchant && <img src={merchant.logo} style={{width: 'auto', height: 48}}/> } */}
      </div>
      <h2>Citizen Data Consent Statement</h2>
      <p className="subtitle">Federal Republic of Nigeria • Data Protection Compliance</p>
    </div>

    <div className="consent-body">
      <p className="intros">
        By submitting this form, I hereby consent to the collection, use, processing, and storage of my personal data for the purpose of delivering the requested government service(s).
      </p>

      <p>I understand that my data may be used to:</p>
      <ul className="consent-lists">
        <li>Verify my identity</li>
        <li>Process my application</li>
        <li>Provide service updates and notifications</li>
        <li>Maintain accurate government records</li>
      </ul>

      <div className="legal-boxs">
        <h4>I acknowledge that:</h4>
        <ul>
          <li>My data will be processed in accordance with the <strong>Nigeria Data Protection Act (NDPA 2023)</strong> and applicable government policies.</li>
          <li>My information will be stored securely within approved government infrastructure and will <strong>not be shared with unauthorized parties</strong>.</li>
          <li>Access is restricted to authorized officials and service providers only for service delivery, audit, or legal compliance.</li>
          <li>I have the right to request access, correction, or deletion of my data as permitted by law.</li>
          <li>I may withdraw consent at any time, but this may prevent service delivery.</li>
        </ul>
      </div>

      <div className="final-declarations">
        <p>
          <strong>By clicking “Submit Application,”</strong> I confirm that I have read, understood, and freely give my consent to this data processing statement.
        </p>
      </div>
     
    </div>
  </div>
  )
  return (
    <div>
      <form onSubmit={handleSubmit}>
        {isMultiPage && (
          <p className="form-page-indicator">Page {currentPage + 1} of {pages.length}</p>
        )}
        {currentPageFields.map((field, index) => (
          <Fragment key={`fied${index}`}>
            <Field field={field} />
          </Fragment>
        ))}
        {isLastPage && (
          <Fragment key={`checkbox-index`}>
            <CheckBox
            field_items={["I hereby consent to the collection, use, processing, and storage of my personal data for the purpose of delivering the requested government service(s)."]}
            isRequired={true}  field_label={"Attestation"}
            modalContent={<Modalcontent />}
            />
          </Fragment>
        )}
        <div className="form-action">

          {/* <Button type="button" onClick={resetForm} className={'clear-form-btn'}>
            Clear Form
          </Button> */}

          {isMultiPage && currentPage > 0 && (
            <Button type="button" onClick={handleBack} className="form-back-btn" style={{ marginRight: "auto" }}>
              Back
            </Button>
          )}

          {isLastPage ? (
            <Button type="submit" className="block" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  Submitting...
                  <Loader size="small" />
                </>
              ) : (
                "Submit"
              )}
            </Button>
          ) : (
            <Button type="button" className="block" onClick={handleNext}>
              Next
            </Button>
          )}
        </div>
      </form>
    </div>
  );
}
